import { makeAxiosRequest } from 'utils/apiMethods';

interface AdminApi {
  fetchDeviceAnalytics: (data: any) => Promise<any>;
}

const adminApi: AdminApi = {
  fetchDeviceAnalytics: makeAxiosRequest(
    `${process.env.REACT_APP_API_URL}/admin/device-analytics`,
    {
      method: 'get',
    },
  ),
};

export default adminApi;
